import { WEIGHT_BOLD } from "@hl/base-components/lib/theme/typography";
import {
  Button,
  Card,
  Stack,
  Text,
  Title,
  useMantineTheme,
} from "@mantine/core";
import { IconCircleX } from "@tabler/icons";

const NoCollectionsFoundForFilter = ({
  clearFilters,
}: {
  clearFilters: () => void;
}) => {
  const theme = useMantineTheme();
  return (
    <Card
      h="100%"
      withBorder={false}
      radius={20}
      bg={theme.colors.tableRowBackground[0]}
      sx={{ alignItems: "center", display: "flex" }}
    >
      <Stack
        spacing={16}
        maw={640}
        w="100%"
        justify="center"
        mx="auto"
        align="center"
      >
        <Title order={5} fw={WEIGHT_BOLD}>
          No collections found matching those filters
        </Title>
        <Text size="sm">Clear all filters to see all of your collections</Text>
        <Button
          mt={16}
          w={240}
          leftIcon={<IconCircleX />}
          onClick={clearFilters}
        >
          Clear filters
        </Button>
      </Stack>
    </Card>
  );
};

export default NoCollectionsFoundForFilter;
